export default __webpack_public_path__ + "static/media/product-options.cf5c7e44.png";